import OnlineBankingDeposit from '../online_banking';
import {DepositsStoreProps} from 'app/store/DepositsStore';

export default class VietnamOnlineBankingDeposit extends OnlineBankingDeposit {
    constructor(props: DepositsStoreProps) {
        super(props);
        this.current_country_code = 'vietnam';
    }
}
